import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Transition } from 'react-transition-group';
import MenuIcon from '../images/icon_menu.svg';

const useStyles = makeStyles({
  menuIcon: {
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    padding: 0,
    '& > img': {
      height: 32,
      width: 32,
    },
  },
  container: {
    position: 'absolute',
    top: 80,
    left: 0,
    right: 0,
    background: '#FFFFFF',
    overflowY: 'hidden',
    overflowX: 'hidden',
    boxShadow: '0 2px 5px rgba(0,0,0,.1)',
    zIndex: 9999,
  },
  wrapper: {
    borderTopWidth: 3,
    borderTopStyle: 'solid',
    borderTopColor: '#2EA3F2',
    padding: 20,
    width: '100%',
    height: '100%',
  },
  header: {
    fontSize: 14,
    fontFamily: 'PoppinsBold',
    color: '#666666',
    padding: '10px 5%',
  },
  headerBackground: {
    backgroundColor: 'rgba(0, 0, 0, 0.03)',
  },
  item: {
    display: 'block',
    fontSize: 14,
    fontFamily: 'PoppinsSemiBold',
    color: '#666666',
    padding: '10px 10%',
    borderBottom: '1px solid rgba(0, 0, 0, 0.03)',
    textDecoration: 'none',
  },
  noDecoration: {
    textDecoration: 'none',
  },
});

const MobileMenu = ({ menu, onClick, onPageExit }) => {
  const classes = useStyles();
  const [showMenu, setShowMenu] = useState(false);

  const defaultStyle = {
    transition: `all 1000ms ease-in-out`,
    maxHeight: 0,
  };

  const transitionStyles = {
    entering: {
      maxHeight: 1000,
    },
    entered: {
      maxHeight: 1000,
    },
    exiting: {
      maxHeight: 0,
    },
    exited: {
      maxHeight: 0,
    },
  };

  const handleScrollTo = hash => {
    if (hash) {
      onClick(hash);
      setShowMenu(false);
    }
  };

  return (
    <>
      <button
        className={classes.menuIcon}
        onClick={() => setShowMenu(value => !value)}
        type="button"
      >
        <img src={MenuIcon} alt="Menu" />
      </button>
      <Transition in={showMenu} timeout={1000}>
        {state => (
          <div
            className={classes.container}
            style={{
              ...defaultStyle,
              ...transitionStyles[state],
            }}
          >
            <div className={classes.wrapper}>
              {menu.map(section => (
                <React.Fragment key={section.title}>
                  <Typography
                    className={_classNames({
                      [classes.header]: true,
                      [classes.headerBackground]: !!section.options,
                    })}
                    onClick={() => handleScrollTo(section.scrollTo)}
                  >
                    {section.title}
                  </Typography>
                  {section.options &&
                    section.options.map(option => (
                      <a
                        key={option.title}
                        href={option.link}
                        className={classes.item}
                        onClick={() => onPageExit(option.link, 'mobile-menu')}
                      >
                        {option.title}
                      </a>
                    ))}
                </React.Fragment>
              ))}
              <Link to="/login" className={classes.noDecoration}>
                <Typography
                  className={_classNames({
                    [classes.header]: true,
                    [classes.headerBackground]: false,
                  })}
                >
                  Sign in
                </Typography>
              </Link>
              <Link to="/signup" className={classes.noDecoration}>
                <Typography
                  className={_classNames({
                    [classes.header]: true,
                    [classes.headerBackground]: false,
                  })}
                >
                  Join now
                </Typography>
              </Link>
            </div>
          </div>
        )}
      </Transition>
    </>
  );
};

MobileMenu.propTypes = {
  menu: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  onPageExit: PropTypes.func.isRequired,
};

export default MobileMenu;
